import type { GameState } from './types'

let context: AudioContext | null = null

export function playGameSound(event: GameState['event'], volume: number, muted: boolean) {
  if (muted || volume <= 0 || !['start', 'eat', 'pause', 'resume', 'gameover', 'win'].includes(event)) return
  context ??= new AudioContext()
  if (context.state === 'suspended') void context.resume()
  const now = context.currentTime
  const oscillator = context.createOscillator()
  const gain = context.createGain()
  const frequencies: Partial<Record<GameState['event'], number>> = {
    start: 220, eat: 620, pause: 180, resume: 280, gameover: 92, win: 880,
  }
  oscillator.type = event === 'gameover' ? 'sawtooth' : 'sine'
  oscillator.frequency.setValueAtTime(frequencies[event] ?? 220, now)
  if (event === 'eat' || event === 'win') oscillator.frequency.exponentialRampToValueAtTime((frequencies[event] ?? 220) * 1.35, now + 0.12)
  gain.gain.setValueAtTime(0.0001, now)
  gain.gain.exponentialRampToValueAtTime(Math.max(0.001, volume / 500), now + 0.015)
  gain.gain.exponentialRampToValueAtTime(0.0001, now + (event === 'gameover' ? 0.35 : 0.16))
  oscillator.connect(gain).connect(context.destination)
  oscillator.start(now)
  oscillator.stop(now + 0.4)
}
